import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {
  @Input() Volume: any;
  @Input() Count: number;
  @Input() TimePeriod:string;
  @Input() List:string;
  @Input() loaderId:string;
  @Input() btnLabel:string;
  @Input() label:string;
  @Input() countlabel:string;
  @Input() isShow:boolean = true;
  @Input() cardColor : 'bgColor1' | 'bgColor2' | 'bgColor3' | 'bgColor4'|'bgColor5' = 'bgColor5';
  @Input() cardButton : 'card-button2' | 'default' = 'default';
  @Input() text : 'custom-text-size-transaction' | 'customerText' |'default' = 'default';
  @Input() count : 'customer-count' | 'count' = 'count';
  @Output() navigateClicked = new EventEmitter<any>();
  @Output() modelOpenTransactionVolume = new EventEmitter<any>();
  @Output() modelOpenTransactionCount = new EventEmitter<any>();
  @Output() modelOpenClicked = new EventEmitter<any>();
  constructor() { }

  ngOnInit(): void {
  }
  onNavigateClicked(event:Event){
    event.stopPropagation();
    this.navigateClicked.emit();
  }
  onmodelOpenTransactionVolume(){
    this.modelOpenTransactionVolume.emit();
  }
  onModelOpenTransactionCount(event:Event){
    event.stopPropagation();
    this.modelOpenTransactionCount.emit();
  }
  onmodelOpenClicked(){
    this.modelOpenClicked.emit();
  }

}
